export function isDataDraft(data) {
  /*
  const { updatedAt: dateUpdate = 0, publishedAt: datePublish = 0 } = data
  return !datePublish || (new Date(datePublish)).getTime() < (new Date(dateUpdate)).getTime()
  */
  const { publishedAt: datePublish = 0 } = data
  return !datePublish
}
